<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>

export default {
}
</script>

<style lang="scss">
@import "~@/assets/common/css/commom";
@import "~@/assets/common/css/style";

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
}

</style>
